<template>
    <!--เบิกล่วงหน้า--->
    <div>
        <!--        <span>{{OtherPaymentList}}</span>-->
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                        v-model="search.employee_id"
                        class="form-control border-0"
                        :options="employeeAll"
                        select-label=""
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="เลือกพนักงาน"
                        :customLabel="employeeLabel"
                        track-by="id">
                    </multiselect>

                    <date-picker
                        v-model="search.date"
                        type="date"
                        :lang="lang"
                        :format="changeFormat"
                        placeholder="วันที่">
                    </date-picker>

                    <multiselect
                        v-model="search.type"
                        class="form-control border-0"
                        :options="optionList"
                        select-label=""
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="เลือกประเภท"
                        :customLabel="typeLabel"
                        track-by="id">
                    </multiselect>

                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchOther"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>

                    <router-link to="other-payment-form">
                        <button class="btn btn-warning my-2 my-sm-0"
                                type="button">
                            <icon name="plus"></icon>
                            เพิ่มรายการจ่าย
                        </button>
                    </router-link>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">รหัสพนักงาน</th>
                    <th scope="col">ชื่อพนักงาน</th>
                    <th scope="col">ยอดเงินหัก</th>
                    <th scope="col">รายการหัก</th>
                    <th scope="col">วันที่หัก</th>
                    <th scope="col">ผู้บันทึก</th>
                    <th scope="col">ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in OtherPaymentList">
                    <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                    <td>
                        <template v-if="data.employee_info">
                            {{ data.employee_info.employee_no }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.employee_info">
                            {{ data.employee_info.first_name }} {{ data.employee_info.last_name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>{{ data.price | currency }}</td>
                    <td>{{ data.select_type_cost }}</td>
                    <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                    <td>
                        {{ data.recorder }}
                    </td>
                    <td>
                        <template v-if="data.employee_info">
                            <a @click="showModalDelete(data.id)">
                                <icon name="trash"></icon>
                            </a>
                        </template>
                        <template v-else :disabled="1">
                            <a>
                                <icon name="pencil-alt"
                                      style="color: grey">
                                </icon>
                            </a>
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="OtherPaymentList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getOtherPaymentList">
            </vue-pagination>
        </div>
        <br>
        <b-modal
            ref="delete_item"
            hide-header
            hide-footer>
            <div style="text-align: center;">
                <h4>คุณต้องการลบใช่หรือไม่</h4>
                <br/>
                <button type="button"
                        class="btn btn-success"
                        @click="DeleteConfirm()">ตกลง
                </button>
                &nbsp&nbsp
                <button type="button"
                        class="btn btn-secondary"
                        @click="hideModalDelete()">ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--        <pre class="alert alert-primary">{{AdvancePaymentList}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex"
import moment from "moment";
import VuePagination from "../../../Pagination";
import Multiselect from "vue-multiselect"
import DatePicker from 'vue2-datepicker'

export default {
    name: "advance-payment",
    components: {
        Multiselect,
        VuePagination,
        DatePicker
    },
    created() {
        this.getOtherPaymentList();
        this.$store.dispatch("Employee/getEmployeeAll").then(res => {
            this.employeeAll = res;
        });
        this.$store.dispatch("Employee/getTypeList").then(res => {
            this.optionList = res;
        });
    },
    computed: {
        ...mapState({
            OtherPaymentList: state => {
                return state.AdvancePayment.OtherPaymentList
            },
            dataPaginate: state => {
                return state.AdvancePayment.dataPaginateOther;
            },
        })
    },
    data() {
        return {
            id: "",
            employeeAll: [],
            optionList: [],
            event_submit: false,
            search: {
                employee_id: '',
                date: '',
                type: '',
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    methods: {
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}`
        },
        typeLabel(option) {
            return `${option.value}`
        },
        hideModalDelete() {
            this.$refs.delete_item.hide();
        },
        showModalDelete(id) {
            this.id = id;
            this.$refs.delete_item.show();
        },
        DeleteConfirm() {
            this.$store.dispatch('AdvancePayment/deleteOtherPayment', this.id).then(() => {
                this.getOtherPaymentList(1);
                this.$refs.delete_item.hide();
            });
        },
        getOtherPaymentList() {
            let page = this.dataPaginate.current_page;
            let data = {
                page: page,
                employee_id: this.search.employee_id ? this.search.employee_id.id : '',
                date: this.search.date ? moment(this.search.date).format("YYYY-MM-DD") : '',
                type: this.search.type ? this.search.type.key : ''
            };
            //console.log(data)
            this.$store.dispatch('AdvancePayment/setOtherPayment', data)
        },
        searchOther() {
            const page = this.dataPaginate.current_page;
            let data = {
                page: page,
                employee_id: this.search.employee_id ? this.search.employee_id.id : '',
                date: this.search.date ? moment(this.search.date).format("YYYY-MM-DD") : '',
                type: this.search.type ? this.search.type.key : ''
            };
            this.$store.dispatch("AdvancePayment/searchOther", data)
            // this.clearSearch();
        },
        clearSearch() {
            this.search.employee_id = '';
            this.search.date = '';
            this.search.type = '';
        }
    }
}
</script>

<style scoped>

</style>
